import React from "react";
import { Toast } from "react-hot-toast";

type SuccessToastProps = {
  toast: Toast;
  title: string;
  message?: string;
  onDismiss: () => void;
};

const SuccessToast = ({
  toast,
  title,
  message,
  onDismiss,
}: SuccessToastProps) => {
  return (
    <div
      className={`w-[22rem] max-w-[calc(100vw-2rem)] border-l-4 border-[#7FB88A] bg-[#EAF7EC] shadow-lg transition-all ${
        toast.visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
      }`}
    >
      <div className="flex gap-4 px-4 py-4">
        <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#7FB88A] text-white">
          <svg viewBox="0 0 20 20" className="h-4 w-4 fill-current" aria-hidden>
            <path d="M7.7 13.3 4.4 10l-1.1 1.1 4.4 4.4 9-9-1.1-1.1z" />
          </svg>
        </div>

        <div className="min-w-0 flex-1">
          <div className="text-[1.05rem] font-semibold leading-6 text-gray-900">
            {title}
          </div>
          {message && (
            <div className="mt-1 text-sm leading-6 text-gray-800">{message}</div>
          )}
        </div>

        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 self-start text-gray-700 transition-colors hover:text-gray-900"
          aria-label="Dismiss notification"
        >
          <svg viewBox="0 0 20 20" className="h-4 w-4 fill-current" aria-hidden>
            <path d="m11.06 10 4.47-4.47-1.06-1.06L10 8.94 5.53 4.47 4.47 5.53 8.94 10l-4.47 4.47 1.06 1.06L10 11.06l4.47 4.47 1.06-1.06z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default SuccessToast;
